import Image from 'next/image';
import ImageSource from '@components/ImageSource/ImageSource';
import VideoPlayer from '@components/Video/VideoPlayer';
import { IVideoPimResponsive, TImage, TVideo, IVideoPim, TFullResponsiveVideo, TMediaFit } from '@components/typescript';
import getImageQuality from '@utils/getImageQuality';
import GetImageAlt from '@utils/getImageAlt';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
import { useResponsive } from '@features/responsive';
import getCurrentDevice from '@utils/getCurrentDevice';
import isVideoUrl from '@utils/isVideoUrl';
import getImageSrc from '@utils/getImageSrc';
const RenderMedia = (images: TImage, videos: IVideoPimResponsive | TVideo = BLANK_VIDEO_OBJECT, playVideo = true, imagesWithBlur: {
  blur: TImage;
  image: TImage;
} | undefined = undefined, alt = '', priority = false, sizes = '100vw', objectFit: TMediaFit = 'cover') => {
  const {
    currentBreakpoint
  } = useResponsive();
  const currentDevice = getCurrentDevice(currentBreakpoint);
  let hasImages = false;
  if (!images) return false;
  const {
    desktop,
    tablet,
    mobile
  } = images;
  const isVideoPim = (video: unknown): video is IVideoPim => typeof video === 'object' && video !== null && 'data' in video;
  const currentVideo = videos && typeof videos !== 'string' ? videos[currentDevice] : null;
  const hasVideoForCurrentDevice = currentVideo && (typeof currentVideo === 'string' || isVideoPim(currentVideo) && isVideoUrl(currentVideo.data));

  // Fallback do desktop video gdy nie ma wideo dla aktualnego urządzenia
  const desktopVideo = videos && typeof videos !== 'string' ? videos.desktop : null;
  const hasDesktopVideo = desktopVideo && (typeof desktopVideo === 'string' || isVideoPim(desktopVideo) && isVideoUrl(desktopVideo.data));
  if (hasVideoForCurrentDevice || hasDesktopVideo) {
    // Tworzymy obiekt wideo z fallbackiem - jeśli nie ma wideo dla aktualnego urządzenia, używamy desktop
    const videoWithFallback = videos && typeof videos !== 'string' ? {
      ...videos,
      [currentDevice]: hasVideoForCurrentDevice ? currentVideo : desktopVideo
    } : videos;
    return <VideoPlayer video={videoWithFallback as TFullResponsiveVideo} playVideo={playVideo} loop poster={imagesWithBlur} priority={priority} />;
  }
  if (!desktop) return <></>;
  if (desktop && tablet && mobile) {
    if (typeof desktop === 'string' && desktop !== '' && tablet !== '' && mobile !== '') hasImages = true;
    if (typeof desktop !== 'string' && typeof tablet !== 'string' && typeof mobile !== 'string' && desktop.path !== '' && tablet.path !== '' && mobile.path !== '') hasImages = true;
  }
  const getAlt = GetImageAlt(images) || alt || '';
  if (hasImages && imagesWithBlur) {
    return <ImageSource imageSources={imagesWithBlur} sizes={sizes} alt={getAlt} priority={priority} objectFit={objectFit} />;
  }
  const blurData = typeof imagesWithBlur?.blur.desktop === 'string' ? imagesWithBlur?.blur.desktop : imagesWithBlur?.blur.desktop?.path;
  if (typeof desktop === 'string' ? desktop : desktop.path) {
    return <Image src={getImageSrc(images, currentDevice)} alt={getAlt} fill quality={getImageQuality()} sizes={sizes} blurDataURL={imagesWithBlur ? blurData : ''} placeholder={imagesWithBlur && imagesWithBlur?.blur?.desktop ? 'blur' : 'empty'} priority={priority} style={{
      objectFit: 'cover',
      objectPosition: 'center'
    }} objectFit={objectFit} />;
  }
  return <></>;
};
export default RenderMedia;